/**
 * 学生路由
  */
import Layout from '@/baseLayout/LayoutPage'
const roleStudent = "students"
export const routesS = {
      path: "/student",
        name:"student",
        component:Layout,
    redirect:"/student/teams",
        children:[
            {
                path: 'teams',
                component: () => import(/* webpackChunkName: "about" */ '../views/students/TeamsView.vue'),
                meta:{title:"参赛队信息管理",menuShow:true,role:roleStudent}
            },
            {
                path: 'addTeam',
                component: () => import(/* webpackChunkName: "about" */ '../views/students/AddTeamView.vue'),
                meta:{title:"添加参赛队员",menuShow:true,role:roleStudent}
            },
            {
                path: 'addTeacher',
                component: () => import(/* webpackChunkName: "about" */ '../views/students/AddTeacherView.vue'),
                meta:{title:"添加辅导老师",menuShow:true,role:roleStudent}
            },
            {
                path: 'downloadDocs',
                component: () => import(/* webpackChunkName: "about" */ '../views/students/DownloadDocs.vue'),
                meta:{title:"参赛文件下载",menuShow:true,role:roleStudent}
            },
            {
                path: 'entry',
                component: () => import(/* webpackChunkName: "about" */ '../views/students/EntryView.vue'),
                meta:{title:"提交参赛作品",menuShow:true,role:roleStudent}
            },
            {
                path: 'repechage',
                component: () => import(/* webpackChunkName: "about" */ '../views/students/RepechageEntryView.vue'),
                meta:{title:"复赛文件上传",menuShow:true,role:roleStudent}
            },
            {
                path: 'awardcertificate',
                component: () =>import(/* webpackChunkName: "about" */ '../views/students/AwardCertificateView.vue'),
                meta:{title:"获奖证书查询",menuShow:true,role:roleStudent}
            },
        ]
    }


